import { render } from "./NewQuote.vue?vue&type=template&id=67a30c6e&scoped=true"
import script from "./NewQuote.vue?vue&type=script&lang=js"
export * from "./NewQuote.vue?vue&type=script&lang=js"

import "./NewQuote.vue?vue&type=style&index=0&id=67a30c6e&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a30c6e"]])

export default __exports__